import { ChannelEditMessageResponse } from "../proto/ChannelEditMessage_pb";
import { ChatEditMessageResponse } from "../proto/ChatEditMessage_pb";
import { GroupEditMessageResponse } from "../proto/GroupEditMessage_pb";
import store from "../store";
import { editRoomMessage } from "../store/messages/actions";
import BaseHandler from "./BaseHandler";

export default class HandleMessagesEditMessageResponse extends BaseHandler<ChatEditMessageResponse | GroupEditMessageResponse | ChannelEditMessageResponse> {
  handle() {
    const messagesEditMessageResponse = this.response.toObject();
    store.dispatch(
      editRoomMessage({
        messageId: messagesEditMessageResponse.messageId,
        message: {
          message: messagesEditMessageResponse.message,
          messageType: messagesEditMessageResponse.messageType,
          messageVersion: messagesEditMessageResponse.messageVersion,
          edited: true,
        },
      })
    );
  }
}
